<template>
    <v-container class="elevation-4 pa-3" white fluid>
        <h5 class="text-h6 mt-2">{{$t('dashboard.title')}}</h5>
        <br>
        <v-row align="start">
             <dashboard-filters
                        v-on:updateFilters="setFilters"
                        v-on:clearFilter="clearFilters"
                        v-on:downloadExcel="downloadExcel"
                        v-on:chartSelectionChange="onChartSelectionChange"
                        :selectedCharts="selectedCharts"
                        v-model="filters"
            />  
        </v-row>
        
        <!-- Gr�ficos por defecto: Ventas por Marca, Ventas por Mes, Ventas por D�a -->
        <v-row align="start" justify="center" class="charts-row">
            <v-col cols="12" sm="3" md="3" class="d-flex justify-center">
                <v-card class="elevation-0 white text-center chart-container">
                    <file-pie-chart class="mb-2" v-if="loadedFilePieChartVentasPorMarca" :chartdata="dataChartPieVentasPorMarca" 
                        :title="$t('dashboard.ventasPorMarca.title')" :options="filePieChartOptions" :update="updateChartVentasPorMarca"/>
                </v-card>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="d-flex justify-center">
                <v-card class="elevation-0 white text-center chart-container" >
                    <file-bar-chart v-if="loadedFileBarChartVentasPorDia" :chartdata="dataChartBarVentasPorDia" 
                        :title="$t('dashboard.ventasPorDia.title')" :options="fileBarChartOptions" :update="updateChartVentasPorDia"/>
                </v-card>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="d-flex justify-center">
                <v-card class="elevation-0 white text-center chart-container">
                    <file-line-chart v-if="loadedFileLineChartVentasPorMes && dataChartLineVentasPorMes && dataChartLineVentasPorMes.labels && dataChartLineVentasPorMes.labels.length > 0" :chartdata="dataChartLineVentasPorMes" 
                        :title="$t('dashboard.ventasPorMes.title')" :options="fileLineChartOptions" :update="updateChartVentasPorMes"/>
                    <div v-else-if="loadedFileLineChartVentasPorMes" class="no-data-message">{{ $t('dashboard.noData') }}</div>
                </v-card>
            </v-col>
        </v-row>
        
        <!-- Gr�ficos seleccionados adicionales (mostrados en filas de 3) -->
        <!-- Debug: selectedCharts = {{ selectedCharts }}, chartRows = {{ chartRows }} -->
        <v-row v-for="(row, rowIndex) in chartRows" :key="`row-${rowIndex}`" align="start" justify="center" class="charts-row">
                    <v-col v-for="chartKey in row" :key="chartKey" cols="12" sm="3" md="3" class="d-flex justify-center">
                        <!-- Ventas por Modelo -->
                        <v-card v-if="chartKey === 'ventasPorModelo'" class="elevation-0 white text-center chart-container">
                            <div v-if="!loadedFilePieChartVentasPorModelo" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                            <file-pie-chart v-else-if="dataChartPieVentasPorModelo && dataChartPieVentasPorModelo.labels && dataChartPieVentasPorModelo.labels.length > 0" class="mb-2" :chartdata="dataChartPieVentasPorModelo" 
                                :title="$t('dashboard.ventasPorModelo.title')" :options="filePieChartOptions" :update="updateChartVentasPorModelo"/>
                            <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                        </v-card>
                        <!-- Ventas por Mes -->
                        <v-card v-if="chartKey === 'ventasPorMes'" class="elevation-0 white text-center chart-container">
                            <div v-if="!loadedFileLineChartVentasPorMes" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                            <file-line-chart v-else-if="dataChartLineVentasPorMes && dataChartLineVentasPorMes.labels && dataChartLineVentasPorMes.labels.length > 0" :chartdata="dataChartLineVentasPorMes" 
                                :title="$t('dashboard.ventasPorMes.title')" :options="fileLineChartOptions" :update="updateChartVentasPorMes"/>
                            <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                        </v-card>
                    <!-- Ventas por Medio de Pago -->
                    <v-card v-if="chartKey === 'ventasPorMedioDePago'" class="elevation-0 white text-center chart-container">
                        <div v-if="!loadedFilePieChartVentasPorMedioDePago" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                        <file-pie-chart v-else-if="dataChartPieVentasPorMedioDePago && dataChartPieVentasPorMedioDePago.labels && dataChartPieVentasPorMedioDePago.labels.length > 0" class="mb-2" :chartdata="dataChartPieVentasPorMedioDePago" 
                            :title="$t('dashboard.ventasPorMedioDePago.title')" :options="filePieChartOptions" :update="updateChartVentasPorMedioDePago"/>
                        <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                    </v-card>
                    <!-- Ventas por Tama�o -->
                    <v-card v-if="chartKey === 'ventasPorTamanio'" class="elevation-0 white text-center chart-container">
                        <div v-if="!loadedFilePieChartVentasPorTamanio" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                        <file-pie-chart v-else-if="dataChartPieVentasPorTamanio && dataChartPieVentasPorTamanio.labels && dataChartPieVentasPorTamanio.labels.length > 0" class="mb-2" :chartdata="dataChartPieVentasPorTamanio" 
                            :title="$t('dashboard.ventasPorTamanio.title')" :options="filePieChartOptions" :update="updateChartVentasPorTamanio"/>
                        <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                    </v-card>
                    <!-- Productos M�s Vendidos -->
                    <v-card v-if="chartKey === 'productosMasVendidos'" class="elevation-0 white text-center chart-container">
                        <div v-if="!loadedFileBarChartProductosMasVendidos" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                        <file-bar-chart v-else-if="dataChartBarProductosMasVendidos && dataChartBarProductosMasVendidos.labels && dataChartBarProductosMasVendidos.labels.length > 0" :chartdata="dataChartBarProductosMasVendidos"
                            :title="$t('dashboard.productosMasVendidos.title')" :options="fileBarChartProductosOptions" :update="updateChartProductosMasVendidos"/>
                        <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                    </v-card>
                    <!-- Ingresos vs Descuentos -->
                    <v-card v-if="chartKey === 'ingresosVsDescuentos'" class="elevation-0 white text-center chart-container">
                        <div v-if="!loadedFileLineChartIngresosVsDescuentos" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                        <file-line-chart v-else-if="dataChartLineIngresosVsDescuentos && dataChartLineIngresosVsDescuentos.labels && dataChartLineIngresosVsDescuentos.labels.length > 0" :chartdata="dataChartLineIngresosVsDescuentos"
                            :title="$t('dashboard.ingresosVsDescuentos.title')" :options="fileLineChartOptions" :update="updateChartIngresosVsDescuentos"/>
                        <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                    </v-card>
                    <!-- Devoluciones por Día -->
                    <v-card v-if="chartKey === 'devolucionesPorDia'" class="elevation-0 white text-center chart-container">
                        <div v-if="!loadedFileLineChartDevolucionesPorDia" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                        <file-line-chart v-else-if="dataChartLineDevolucionesPorDia && dataChartLineDevolucionesPorDia.labels && dataChartLineDevolucionesPorDia.labels.length > 0" :chartdata="dataChartLineDevolucionesPorDia"
                            :title="$t('dashboard.devolucionesPorDia.title')" :options="fileLineChartOptions" :update="updateChartDevolucionesPorDia"/>
                        <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                    </v-card>
                    <!-- Órdenes de Venta por Día -->
                    <v-card v-if="chartKey === 'ordenesVentaPorDia'" class="elevation-0 white text-center chart-container">
                        <div v-if="!loadedFileBarChartOrdenesVentaPorDia" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                        <file-bar-chart v-else-if="dataChartBarOrdenesVentaPorDia && dataChartBarOrdenesVentaPorDia.labels && dataChartBarOrdenesVentaPorDia.labels.length > 0" :chartdata="dataChartBarOrdenesVentaPorDia"
                            :title="$t('dashboard.ordenesVentaPorDia.title')" :options="fileBarChartOptions" :update="updateChartOrdenesVentaPorDia"/>
                        <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                    </v-card>
                    <!-- Órdenes de Compra por Día -->
                    <v-card v-if="chartKey === 'ordenesCompraPorDia'" class="elevation-0 white text-center chart-container">
                        <div v-if="!loadedFileBarChartOrdenesCompraPorDia" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                        <file-bar-chart v-else-if="dataChartBarOrdenesCompraPorDia && dataChartBarOrdenesCompraPorDia.labels && dataChartBarOrdenesCompraPorDia.labels.length > 0" :chartdata="dataChartBarOrdenesCompraPorDia"
                            :title="$t('dashboard.ordenesCompraPorDia.title')" :options="fileBarChartOptions" :update="updateChartOrdenesCompraPorDia"/>
                        <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                    </v-card>
                    <!-- Flujo de Caja por Día -->
                    <v-card v-if="chartKey === 'flujoCajaPorDia'" class="elevation-0 white text-center chart-container">
                        <div v-if="!loadedFileLineChartFlujoCajaPorDia" class="no-data-message">{{ $t('dashboard.loading') || 'Cargando...' }}</div>
                        <file-line-chart v-else-if="dataChartLineFlujoCajaPorDia && dataChartLineFlujoCajaPorDia.labels && dataChartLineFlujoCajaPorDia.labels.length > 0" :chartdata="dataChartLineFlujoCajaPorDia"
                            :title="$t('dashboard.flujoCajaPorDia.title')" :options="fileLineChartOptions" :update="updateChartFlujoCajaPorDia"/>
                        <div v-else class="no-data-message">{{ $t('dashboard.noData') }}</div>
                    </v-card>
                </v-col>
            </v-row>
        
    </v-container>

</template>

<script>
    import dashboardProvider from "../../../providers/DashboardProvider";
    // import redeableBytesMixin from '../../mixins/readableBytesMixin';
    import FileBarChart from '../../../components/FileBarChart'
    import FilePieChart from '../../../components/FilePieChart'
    import FileLineChart from '../../../components/FileLineChart'
    import DashboardFilters from '../DashboardFilters'
    import { validateDateRange } from '../../../util/dateFilters';

    export default {
        name: "DashboardManagement",
        components: { FilePieChart, FileBarChart, FileLineChart, DashboardFilters },
        data() {
            return {
                fileGlobalMetrics: null,
                fileUserMetrics:null,
                ventasPorMarca:null,
                loadedFilePieChartVentasPorModelo: false,
                loadedFilePieChartVentasPorMarca: false,
                loadedFileBarChartVentasPorDia: false,
                loadedFilePieChartVentasPorMedioDePago: false,
                loadedFilePieChartVentasPorTamanio: false,
                loadedFileBarChartProductosMasVendidos: false,
                loadedFileLineChartIngresosVsDescuentos: false,
                loadedFileLineChartVentasPorMes: false,
                loadedFileLineChartDevolucionesPorDia: false,
                loadedFileBarChartOrdenesVentaPorDia: false,
                loadedFileBarChartOrdenesCompraPorDia: false,
                loadedFileLineChartFlujoCajaPorDia: false,
                fileBarChartOptions: {
                    title: {
                        display: true,
                        text: this. $t("dashboard.ventasPorDia.title"),
                        fontSize: '14'
                    },
                    plugins: {
                        labels: {
                            render: () => {
                                return ''; // Deshabilitar labels completamente
                            },
                            fontSize: 0,
                            fontColor: 'transparent'
                        },
                        datalabels: {
                            display: false
                        }
                    },
                    legend: {
                        labels: {
                            fontSize: 12
                        },
                        position: 'bottom'
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    fontSize: 11
                                }
                            }
                        ], 
                        xAxes: [
                            {
                                ticks: {
                                    fontSize: 11
                                }
                            }
                        ], 
                    },
                    maintainAspectRatio: false
                },
                fileBarChartProductosOptions: {
                    title: {
                        display: true,
                        text: '',
                        fontSize: '14'
                    },
                    plugins: {
                        labels: {
                            render: () => {
                                return '';
                            },
                            fontSize: 0,
                            fontColor: 'transparent'
                        },
                        datalabels: {
                            display: false
                        }
                    },
                    legend: {
                        labels: {
                            fontSize: 12
                        },
                        position: 'bottom'
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    fontSize: 11
                                }
                            }
                        ],
                        xAxes: [
                            {
                                ticks: {
                                    fontSize: 11,
                                    callback: function(value) {
                                        var max = 18;
                                        return typeof value === 'string' && value.length > max
                                            ? value.substring(0, max) + '…'
                                            : value;
                                    }
                                }
                            }
                        ]
                    },
                    maintainAspectRatio: false
                },
                filePieChartOptions: {
                    plugins: {
                        labels: {
                            render: (value) => { 
                                if (value.percentage != 'Nan') {
                                    if (value.value % 1 == 0) {
                                        if (value.value != 0) {
                                            return Math.trunc(value.value)
                                        }
                                    } else {
                                        return value.value.toFixed(2)
                                    }
                                }
                            },
                            fontSize: '12',
                            fontColor: 'black',
                        },
                        title: {
                            fontSize: 14
                        }
                    },
                    legend: {
                        labels: {
                            fontSize: 12
                        },
                        position: 'bottom'
                    },
                    maintainAspectRatio: false
                },
                fileLineChartOptions: {
                    title: {
                        display: true,
                        fontSize: '14'
                    },
                    plugins: {
                        labels: {
                            render: () => '',
                            fontSize: '0',
                            fontColor: 'transparent'
                        },
                        datalabels: {
                            display: false
                        }
                    },
                    legend: {
                        labels: {
                            fontSize: 12
                        },
                        position: 'bottom'
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    fontSize: 11
                                }
                            }
                        ], 
                        xAxes: [
                            {
                                ticks: {
                                    fontSize: 11
                                }
                            }
                        ], 
                    },
                    maintainAspectRatio: false
                },  
                dataChart: { },
                dataChartPieVentasPorMarca: { labels: [], datasets: [] },
                dataChartPieVentasPorModelo: { labels: [], datasets: [] },
                dataChartBarVentasPorDia: { labels: [], datasets: [] },
                dataChartPieVentasPorMedioDePago: { labels: [], datasets: [] },
                dataChartPieVentasPorTamanio: { labels: [], datasets: [] },
                dataChartBarProductosMasVendidos: { labels: [], datasets: [] },
                dataChartLineIngresosVsDescuentos: { labels: [], datasets: [] },
                dataChartLineVentasPorMes: { labels: [], datasets: [] },
                dataChartLineDevolucionesPorDia: { labels: [], datasets: [] },
                dataChartBarOrdenesVentaPorDia: { labels: [], datasets: [] },
                dataChartBarOrdenesCompraPorDia: { labels: [], datasets: [] },
                dataChartLineFlujoCajaPorDia: { labels: [], datasets: [] },
                filters: [
                    {
                        field: 'dateFrom',
                        operator: '$gte',
                        value: null
                    },
                    {
                        field: 'dateTo',
                        operator: '$lte',
                        value: null
                    },
                    {
                        field: 'deposito',
                        operator: '$eq',
                        value: null
                    },
                ],
                updateChartVentasPorMarca: false,
                updateChartVentasPorModelo: false,
                updateChartVentasPorDia: false,
                updateChartVentasPorMedioDePago: false,
                updateChartVentasPorTamanio: false,
                updateChartProductosMasVendidos: false,
                updateChartIngresosVsDescuentos: false,
                updateChartVentasPorMes: false,
                updateChartDevolucionesPorDia: false,
                updateChartOrdenesVentaPorDia: false,
                updateChartOrdenesCompraPorDia: false,
                updateChartFlujoCajaPorDia: false,
                selectedCharts: [] // Gr�ficos seleccionados adicionales
            }
        },
        computed: {
            // Dividir los gr�ficos seleccionados en filas de 3
            chartRows() {
                // Obtener el valor real del array, evitando problemas con Observers
                let charts = this.selectedCharts;
                
                // Si charts tiene _ob_ (es un Observer), extraer el array real
                if (charts && charts._ob_) {
                    // Si tiene length, es un array reactivo, usar Array.from para crear una copia limpia
                    if (typeof charts.length === 'number') {
                        charts = Array.from(charts);
                    } else if (charts.value) {
                        charts = Array.isArray(charts.value) ? charts.value : [];
                    } else {
                        charts = [];
                    }
                }
                
                // Asegurar que sea un array v�lido
                if (!Array.isArray(charts)) {
                    charts = [];
                }
                
                // Filtrar cualquier elemento que no sea un string v�lido
                charts = charts.filter(chart => typeof chart === 'string' && chart.length > 0);
                
                const rows = [];
                for (let i = 0; i < charts.length; i += 3) {
                    rows.push(charts.slice(i, i + 3));
                }
                
                return rows;
            }
        },
        created() {
            this.loadedFilePieChartVentasPorMarca = false;
            this.loadedFilePieChartVentasPorModelo = false;
            this.loadedFileBarChartVentasPorDia = false;
            this.loadedFilePieChartVentasPorMedioDePago = false;
            this.loadedFilePieChartVentasPorTamanio = false;
            this.loadedFileBarChartProductosMasVendidos = false;
            this.loadedFileLineChartIngresosVsDescuentos = false;
            this.loadedFileLineChartVentasPorMes = false;
            this.loadedFileLineChartDevolucionesPorDia = false;
            this.loadedFileBarChartOrdenesVentaPorDia = false;
            this.loadedFileBarChartOrdenesCompraPorDia = false;
            this.loadedFileLineChartFlujoCajaPorDia = false;
            this.getCharts();
        },
        methods: {
            getVentasPorMarca() {
                this.updateChartVentasPorMarca = true; 
                dashboardProvider.getChartDataVentasPorMarca(this.filters).then(r => {
                    let results = r.data.chartDataVentasPorMarca
                    this.dataChartPieVentasPorMarca.datasets = [results.dataset[0]];
                    this.dataChartPieVentasPorMarca.labels = results.labels;

                }).catch(err => {
                    console.error(err)
                }).finally(()=>{
                    this.loadedFilePieChartVentasPorMarca = true
                    this.updateChartVentasPorMarca = false;
                })
            },
            getVentasPorModelo() {
                this.updateChartVentasPorModelo = true; 
                dashboardProvider.getChartDataVentasPorModelo(this.filters).then(r => {
                    let results = r.data.chartDataVentasPorModelo

                    this.dataChartPieVentasPorModelo.datasets = [results.dataset[0]];
                    this.dataChartPieVentasPorModelo.labels = results.labels;
                }).catch(err => {
                    console.error(err)
                }).finally(()=>{
                    this.loadedFilePieChartVentasPorModelo = true;
                    this.updateChartVentasPorModelo = false;
                })
            },
            getVentasPorDia() {
                this.updateChartVentasPorDia = true;
                dashboardProvider.getChartDataVentasPorDia(this.filters).then(r => {
                    let results = r.data.chartDataVentasPorDia

                    this.dataChartBarVentasPorDia.datasets = [results.dataset[0]];
                    this.dataChartBarVentasPorDia.labels = results.labels;

                }).catch(err => {
                    console.error(err)
                }).finally(()=>{
                    this.loadedFileBarChartVentasPorDia = true;
                    this.updateChartVentasPorDia = false;
                })
            },
            setFilters(dashboardFilters) {
                const fechaDesde = dashboardFilters[0]?.value;
                const fechaHasta = dashboardFilters[1]?.value;
                
                // Validar fechas usando la funci�n gen�rica
                const validation = validateDateRange(fechaDesde, fechaHasta);
                
                // Si la validaci�n pasa, actualizar filtros y recargar gr�ficos
                if (validation.isValid) {
                    this.filters = dashboardFilters;
                    this.getCharts();
                }
            },
            clearFilters() {
                this.filters.forEach(filter => {
                    filter.value = null
                })
                this.getCharts();
            },
            getVentasPorMedioDePago() {
                this.updateChartVentasPorMedioDePago = true;
                dashboardProvider.getChartDataVentasPorMedioDePago(this.filters).then(r => {
                    let results = r.data.chartDataVentasPorMedioDePago
                    // Reemplazar el objeto completo para asegurar reactividad
                    this.$set(this, 'dataChartPieVentasPorMedioDePago', {
                        labels: results.labels || [],
                        datasets: results.dataset ? [results.dataset[0]] : []
                    });
                }).catch(err => {
                    console.error(err)
                }).finally(() => {
                    this.loadedFilePieChartVentasPorMedioDePago = true;
                    this.updateChartVentasPorMedioDePago = false;
                })
            },
            getVentasPorTamanio() {
                this.updateChartVentasPorTamanio = true;
                dashboardProvider.getChartDataVentasPorTamanio(this.filters).then(r => {
                    let results = r.data.chartDataVentasPorTamanio
                    this.$set(this, 'dataChartPieVentasPorTamanio', {
                        labels: results.labels || [],
                        datasets: results.dataset ? [results.dataset[0]] : []
                    });
                }).catch(err => {
                    console.error(err)
                }).finally(() => {
                    this.loadedFilePieChartVentasPorTamanio = true;
                    this.updateChartVentasPorTamanio = false;
                })
            },
            getProductosMasVendidos() {
                this.updateChartProductosMasVendidos = true;
                dashboardProvider.getChartDataProductosMasVendidos(this.filters).then(r => {
                    let results = r.data.chartDataProductosMasVendidos
                    this.$set(this, 'dataChartBarProductosMasVendidos', {
                        labels: results.labels || [],
                        datasets: results.dataset ? [results.dataset[0]] : []
                    });
                }).catch(err => {
                    console.error(err)
                }).finally(() => {
                    this.loadedFileBarChartProductosMasVendidos = true;
                    this.updateChartProductosMasVendidos = false;
                })
            },
            getIngresosVsDescuentos() {
                this.updateChartIngresosVsDescuentos = true;
                dashboardProvider.getChartDataIngresosVsDescuentos(this.filters).then(r => {
                    let results = r.data.chartDataIngresosVsDescuentos
                    this.$set(this, 'dataChartLineIngresosVsDescuentos', {
                        labels: results.labels || [],
                        datasets: results.dataset || []
                    });
                }).catch(err => {
                    console.error(err)
                }).finally(() => {
                    this.loadedFileLineChartIngresosVsDescuentos = true;
                    this.updateChartIngresosVsDescuentos = false;
                })
            },
            getVentasPorMes() {
                this.updateChartVentasPorMes = true;
                dashboardProvider.getChartDataVentasPorMes(this.filters).then(r => {
                    let results = r.data.chartDataVentasPorMes
                    this.$set(this, 'dataChartLineVentasPorMes', {
                        labels: results.labels || [],
                        datasets: results.dataset || []
                    });
                }).catch(err => {
                    console.error(err)
                }).finally(() => {
                    this.loadedFileLineChartVentasPorMes = true;
                    this.updateChartVentasPorMes = false;
                })
            },
            onChartSelectionChange(selectedCharts) {
                // Extraer el array real si viene envuelto en un Observer
                let chartsArray = selectedCharts;
                
                // Si tiene _ob_ pero tambi�n tiene length, es un array reactivo de Vue
                if (selectedCharts && selectedCharts._ob_ && typeof selectedCharts.length === 'number') {
                    // Es un array reactivo, crear una copia limpia usando Array.from
                    chartsArray = Array.from(selectedCharts).filter(item => typeof item === 'string');
                } else if (selectedCharts && selectedCharts._ob_) {
                    // Es un Observer pero no un array, intentar obtener el value
                    chartsArray = selectedCharts.value || [];
                } else if (Array.isArray(selectedCharts)) {
                    // Ya es un array, crear una copia limpia
                    chartsArray = [...selectedCharts].filter(item => typeof item === 'string');
                } else {
                    chartsArray = [];
                }
                
                // Actualizar la propiedad selectedCharts directamente (Vue har� el array reactivo autom�ticamente)
                this.selectedCharts = chartsArray;
                
                // Cargar solo los gr�ficos nuevos (los que est�n seleccionados pero a�n no cargados)
                this.loadNewCharts(chartsArray);
            },
            loadNewCharts(selectedCharts) {
                // Verificar que haya un dep�sito seleccionado
                const depositoFilter = this.filters.find(f => f.field === 'deposito');
                if (!depositoFilter || (!depositoFilter.value && depositoFilter.value !== 'ALL')) {
                    return;
                }
                
                // Asegurar que selectedCharts sea un array
                const charts = selectedCharts || [];
                
                // Cargar solo los gr�ficos que est�n seleccionados pero a�n no est�n cargados
                if (charts.includes('ventasPorModelo') && !this.loadedFilePieChartVentasPorModelo) {
                    this.getVentasPorModelo();
                }
                if (charts.includes('ventasPorMes') && !this.loadedFileLineChartVentasPorMes) {
                    this.getVentasPorMes();
                }
                if (charts.includes('ventasPorMedioDePago') && !this.loadedFilePieChartVentasPorMedioDePago) {
                    this.getVentasPorMedioDePago();
                }
                if (charts.includes('ventasPorTamanio') && !this.loadedFilePieChartVentasPorTamanio) {
                    this.getVentasPorTamanio();
                }
                if (charts.includes('productosMasVendidos') && !this.loadedFileBarChartProductosMasVendidos) {
                    this.getProductosMasVendidos();
                }
                if (charts.includes('ingresosVsDescuentos') && !this.loadedFileLineChartIngresosVsDescuentos) {
                    this.getIngresosVsDescuentos();
                }
                if (charts.includes('devolucionesPorDia') && !this.loadedFileLineChartDevolucionesPorDia) {
                    this.getDevolucionesPorDia();
                }
                if (charts.includes('ordenesVentaPorDia') && !this.loadedFileBarChartOrdenesVentaPorDia) {
                    this.getOrdenesVentaPorDia();
                }
                if (charts.includes('ordenesCompraPorDia') && !this.loadedFileBarChartOrdenesCompraPorDia) {
                    this.getOrdenesCompraPorDia();
                }
                if (charts.includes('flujoCajaPorDia') && !this.loadedFileLineChartFlujoCajaPorDia) {
                    this.getFlujoCajaPorDia();
                }
            },
            loadSelectedCharts(selectedCharts) {
                // Verificar que haya un dep�sito seleccionado
                const depositoFilter = this.filters.find(f => f.field === 'deposito');
                if (!depositoFilter || (!depositoFilter.value && depositoFilter.value !== 'ALL')) {
                    return;
                }
                
                // Siempre cargar los gr�ficos por defecto
                this.getVentasPorMarca(this.filters);
                this.getVentasPorMes();
                this.getVentasPorDia(this.filters);
                
                // Asegurar que selectedCharts sea un array
                const charts = selectedCharts || [];
                
                // Cargar solo los gr�ficos seleccionados (resetear estado y cargar)
                if (charts.includes('ventasPorModelo')) {
                    this.loadedFilePieChartVentasPorModelo = false;
                    this.getVentasPorModelo();
                }
                if (charts.includes('ventasPorMes')) {
                    this.loadedFileLineChartVentasPorMes = false;
                    this.getVentasPorMes();
                }
                if (charts.includes('ventasPorMedioDePago')) {
                    this.loadedFilePieChartVentasPorMedioDePago = false;
                    this.getVentasPorMedioDePago();
                }
                if (charts.includes('ventasPorTamanio')) {
                    this.loadedFilePieChartVentasPorTamanio = false;
                    this.getVentasPorTamanio();
                }
                if (charts.includes('productosMasVendidos')) {
                    this.loadedFileBarChartProductosMasVendidos = false;
                    this.getProductosMasVendidos();
                }
                if (charts.includes('ingresosVsDescuentos')) {
                    this.loadedFileLineChartIngresosVsDescuentos = false;
                    this.getIngresosVsDescuentos();
                }
                if (charts.includes('devolucionesPorDia')) {
                    this.loadedFileLineChartDevolucionesPorDia = false;
                    this.getDevolucionesPorDia();
                }
                if (charts.includes('ordenesVentaPorDia')) {
                    this.loadedFileBarChartOrdenesVentaPorDia = false;
                    this.getOrdenesVentaPorDia();
                }
                if (charts.includes('ordenesCompraPorDia')) {
                    this.loadedFileBarChartOrdenesCompraPorDia = false;
                    this.getOrdenesCompraPorDia();
                }
                if (charts.includes('flujoCajaPorDia')) {
                    this.loadedFileLineChartFlujoCajaPorDia = false;
                    this.getFlujoCajaPorDia();
                }
            },
            getCharts() {
                // Verificar que haya un dep�sito seleccionado
                const depositoFilter = this.filters.find(f => f.field === 'deposito');
                if (!depositoFilter || (!depositoFilter.value && depositoFilter.value !== 'ALL')) {
                    return;
                }
                
                // Cargar gr�ficos por defecto y los seleccionados
                this.loadSelectedCharts(this.selectedCharts);
            },
            getDevolucionesPorDia() {
                this.updateChartDevolucionesPorDia = true;
                dashboardProvider.getChartDataDevolucionesPorDia(this.filters).then(r => {
                    let results = r.data.chartDataDevolucionesPorDia;
                    this.$set(this, 'dataChartLineDevolucionesPorDia', {
                        labels: results.labels || [],
                        datasets: results.dataset || []
                    });
                }).catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loadedFileLineChartDevolucionesPorDia = true;
                    this.updateChartDevolucionesPorDia = false;
                });
            },
            getOrdenesVentaPorDia() {
                this.updateChartOrdenesVentaPorDia = true;
                dashboardProvider.getChartDataOrdenesVentaPorDia(this.filters).then(r => {
                    let results = r.data.chartDataOrdenesVentaPorDia;
                    this.$set(this, 'dataChartBarOrdenesVentaPorDia', {
                        labels: results.labels || [],
                        datasets: results.dataset ? [results.dataset[0]] : []
                    });
                }).catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loadedFileBarChartOrdenesVentaPorDia = true;
                    this.updateChartOrdenesVentaPorDia = false;
                });
            },
            getOrdenesCompraPorDia() {
                this.updateChartOrdenesCompraPorDia = true;
                dashboardProvider.getChartDataOrdenesCompraPorDia(this.filters).then(r => {
                    let results = r.data.chartDataOrdenesCompraPorDia;
                    this.$set(this, 'dataChartBarOrdenesCompraPorDia', {
                        labels: results.labels || [],
                        datasets: results.dataset ? [results.dataset[0]] : []
                    });
                }).catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loadedFileBarChartOrdenesCompraPorDia = true;
                    this.updateChartOrdenesCompraPorDia = false;
                });
            },
            getFlujoCajaPorDia() {
                this.updateChartFlujoCajaPorDia = true;
                dashboardProvider.getChartDataFlujoCajaPorDia(this.filters).then(r => {
                    let results = r.data.chartDataFlujoCajaPorDia;
                    this.$set(this, 'dataChartLineFlujoCajaPorDia', {
                        labels: results.labels || [],
                        datasets: results.dataset || []
                    });
                }).catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loadedFileLineChartFlujoCajaPorDia = true;
                    this.updateChartFlujoCajaPorDia = false;
                });
            },
            downloadExcel() {
                dashboardProvider.generateExcel(this.filters).then(() => {
                    // Excel generado
                }).catch(err => {
                    console.error(err)
                })
            }
        }
    }
</script>

<style scoped>
.charts-row {
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.chart-container {
    min-height: 400px;
    max-height: 450px;
    padding: 12px !important;
    overflow: visible;
    width: 100%;
    max-width: 100%;
}

.chart-container canvas {
    max-height: 320px !important;
}

.chart-container .v-card__text {
    padding: 8px !important;
    overflow: visible;
}

.d-flex.justify-center {
    display: flex;
    justify-content: center;
}

.no-data-message {
    padding: 40px;
    text-align: center;
    color: #999;
}
</style>
